import { button, quote, route } from '../../config';
import errorImage from '../../assets/images/lamp.png'

/**
 * FallBack Component to hand UI breakage
 * @returns 
 */
const FallBack = () => {

    /**
     * redirects to tasks page 
     */
    const handleRetry = () => {
        window.location.href = route.PRIVATE_ROUTE.TASKS.PATH;
    };

    /**
     * redirects to login page
     */
    const handleLoginAgain = () => {
        window.location.href = route.ROUTE.LOGIN.PATH;
    };

    return (
        <div className="fallback-container d-flex flex-column align-items-center justify-content-center text-center p-4" role="alert">
            <div className="warning-sign-container mb-3">
                <img src={errorImage} alt="warning sign" className="warning-sign-img" />
            </div>
            <h1 className="fallback-title mb-0 mt-3">{quote.SOMETHING_WENT_WRONG}</h1>
            <p className="fallback-message my-4">{quote.TRY_AGAIN_LATER}</p>
            <div className='fallback-btns d-flex mt-3'>
                <button id='fallback-try-again-btn' onClick={handleRetry} className="btn btn-primary fallback-button-size mr-3">
                    {button.TRY_AGAIN}
                </button>
                <button id='fallback-login-btn' onClick={handleLoginAgain} className="btn btn-ghost fallback-button-size ml-2 fallback-bdr-button">
                    {button.LOGIN}
                </button>
            </div>
        </div>
    );
};

export default FallBack